import React, { Fragment, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { useContext } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { toast } from 'react-toastify';
import socket from '../socket/socket';

import Taptop from './TapTop';
import Header from './Header';
import Sidebar from './Sidebar';
import ThemeCustomize from '../Layout/ThemeCustomizer';
import Footer from './Footer';
import CustomizerContext from '../_helper/Customizer';
import AnimationThemeContext from '../_helper/AnimationTheme';
import ConfigDB from '../Config/ThemeConfig';
import Loader from '../CommonElements/Loader/loader';
import { merchantProfile } from '../api-handle/authApi';
import { refreshMenuItems } from './Sidebar/Menu';
import { jwtDecode } from 'jwt-decode';
import { NotificationContext } from '../Components/Pages/Notifications/NotificationContext';

const AppLayout = ({ children, classNames, ...rest }) => {
  const { layout } = useContext(CustomizerContext);
  const { sidebarIconType } = useContext(CustomizerContext);
  const { setNotifications } = useContext(NotificationContext)

  const layout1 = localStorage.getItem('sidebar_layout') || layout;
  const sideBarIcon = localStorage.getItem('sidebar_icon_type') || sidebarIconType;
  const location = useLocation();
  const { animation } = useContext(AnimationThemeContext);
  const animationTheme = localStorage.getItem('animation') || animation || ConfigDB.data.router_animation;
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [disable, setDisable] = useState(false)

  let merchantId;

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        merchantId = decoded?.merchant;
      } catch (err) {
        console.error("Invalid token:", err);
      }
    }
  }, []);

  // Inside AppLayout.jsx
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await merchantProfile();
        if (res.isSuccess) {
          const userData = res.user;
          // `type` comes back as populated Type refs ({ _id, key, ... }) —
          // the menu exclusion map is keyed by the string keys ("gym", ...).
          const typeKeys = (res?.user?.merchant?.type || [])
            .map((t) => (t && typeof t === "object" ? t.key : t))
            .filter(Boolean)
            .join(",");
          localStorage.setItem("merchant-types", typeKeys);
          refreshMenuItems();
          setUser(userData);

          if (userData.userType === 'merchant') {
            const merchant = userData.merchant;

            if (!merchant) {
              navigate('/merchant/details');
              setDisable(true)
              return;
            }

            if (merchant.status === 'pending') {
              setDisable(true)
              // Don't redirect to dashboard - redirect to a safe page like profile if they're on dashboard
              const currentPath = location.pathname;
              if (currentPath === '/pages/dashboard' || currentPath.startsWith('/pages/dashboard')) {
                navigate('/merchant/profile');
              }
              return;
            }

            if (merchant.status === 'declined') {
              // Pass the user (or merchant) data to the declined route
              navigate('/merchant/declined', { state: { merchant } });
              setDisable(true)
              return;
            }
            // if (merchant.status === 'approved') {
            //   console.log("Navigating to Declined")
            //   // Pass the user (or merchant) data to the declined route
            //   navigate('/pages/dashboard', { state: { merchant } });
            //   return;
            // }
          }
        }
      } catch (err) {
        // Do NOT log the user out here. Transient failures (network blips, slow
        // backend, 5xx) must not end the session. Genuine auth failures (401 with
        // an expired/absent token) are handled centrally by the axios response
        // interceptor, which logs out and redirects.
        console.error("Failed to fetch profile", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  useEffect(() => {
    const handleDeleteMerchant = (data) => {
      navigate('/merchant/deleted', { state: { data } });
    };

    socket.on("connect", () => {
      if (merchantId) {
        socket.emit("join", merchantId);
      }
    });

    socket.on("deleteMerchant", handleDeleteMerchant);

    return () => {
      socket.off("connect");
      socket.off("deleteMerchant", handleDeleteMerchant);
    };
  }, [merchantId]);

  useEffect(() => {

    if (merchantId) {
      socket.emit("join", merchantId);

      socket.on("connect", () => { });

      socket.on("newNotification", (data) => {
        setNotifications((prev) => [data, ...prev]);
      });
    }

    return () => {
      socket.off("newNotification");
    };
  }, [merchantId]);


  if (loading) return <Loader />;

  return (
    <Fragment>
      {user && <>
        {/* <Loader /> */}
        <Taptop />
        <div className={`page-wrapper ${layout1}`} sidebar-layout={sideBarIcon} id='pageWrapper'>
          <Header />
          <div className='page-body-wrapper'>
            {<Sidebar user={user} disable={disable} />}
            <div className='page-body'>
              <TransitionGroup {...rest}>
                <CSSTransition key={location.key} timeout={100} classNames={animationTheme} unmountOnExit>
                  <div>
                    <div>
                      <Outlet />
                    </div>
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
            <Footer />
          </div>
        </div>
        {/* <ThemeCustomize /> */}
      </>}
    </Fragment>
  );
};
export default AppLayout;
